// this file contains custom scripts made by a Nara developer directly, they were not automatically created


// On scroll function for the button that scrolls toward the map of places where customers can buy water

document.addEventListener('DOMContentLoaded', function() {
  var button = document.getElementById('trigger-button'); // Replace 'example_id' with your button's ID
  var targetElement = document.getElementById('target-div'); // Replace 'target_element_id' with your target element's ID
  if (button) {
    button.addEventListener('click', function() {
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
      else{
        console.log("missing target element id")
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var button = document.getElementById('scroll-button');
  var targetElement = document.getElementById('banner-target'); // Ensure this id is assigned on the destination section

  if (button) {
    button.addEventListener('click', function() {
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.log("Missing target element with specified ID");
      }
    });
  } else {
    console.log("Scroll button not found");
  }
});




